// extracted by mini-css-extract-plugin
module.exports = {"axisLine":"ChartAxisPreset__axisLine__M45JI","axisTicks":"ChartAxisPreset__axisTicks__Fqvav"};